"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NotificationServiceImplBase_1 = require("./NotificationServiceImplBase");
class NotificationServiceImpl extends NotificationServiceImplBase_1.NotificationServiceImplBase {
    get serviceName() {
        return "notification-service" /* Notification */;
    }
}
exports.NotificationServiceImpl = NotificationServiceImpl;
//# sourceMappingURL=NotificationServiceImpl.js.map